import unitHelper from '@client/helper/unit';
import Definition from '@client/config/definition';
// 公制key
const METRIC_UNITS = Definition.METRIC_UNITS;
// 英制key
const IMPERIAL_UNITS = Definition.IMPERIAL_UNITS;

export const fieldFormatConfig = {
  // 最大冲坠（Max Activity Fall）
  MaxActivityFall: {
    getUnit: (unitType) => {
      return {
        [METRIC_UNITS]: 'm',
        [IMPERIAL_UNITS]: 'ft'
      }[unitType];
    },
    getValue: (val, unitType) => {
      const value = {
        [METRIC_UNITS]: (value) => {
          return value.toFixed(1);
        },
        [IMPERIAL_UNITS]: (value) => {
          return unitHelper.distanceM2ft(value, 1, unitType);
        }
      }[unitType](val);

      return value;
    },
    format: (val, unitType) => {
      const unit = fieldFormatConfig.MaxActivityFall.getUnit(unitType);
      const value = fieldFormatConfig.MaxActivityFall.getValue(val, unitType);
      return [value, unit];
    }
  },
  // 总上升（Total Ascent）
  Total_Ascent: {
    format: (val, unitType) => {
      const unit = {
        [METRIC_UNITS]: 'm',
        [IMPERIAL_UNITS]: 'ft'
      }[unitType];

      const value = {
        [METRIC_UNITS]: (value) => {
          return value.toFixed(1);
        },
        [IMPERIAL_UNITS]: (value) => {
          return unitHelper.distanceM2ft(value, 1, unitType);
        }
      }[unitType](val);

      return [value, unit];
    }
  }
};
